// Generate code from clean architecture template

import { CourseTopicEntity } from '../entities';
import { CourseTopicPayloadForm } from '../ports/payloads';
import { CourseTopicRepository } from '../ports/repositories';

export class UpdateCourseTopicUsecase {
  constructor(private readonly repo: CourseTopicRepository) {}

  async run(payload: CourseTopicPayloadForm): Promise<CourseTopicEntity> {
    const data = await this.repo.updateCourseTopic(payload);
    return data;
  }
}
